import styled from "styled-components";

const MOBILE_BREAKPOINT = "768px";

export const Wrapper = styled.div`
    display: flex;
    gap: 10px;
    flex-direction: column;
    width: 100%;
    flex-shrink: 0;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        width: 100%;
        max-width: 100%;
    }
`;

export const InfoContainer = styled.div`
    background: white;
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 100%;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        padding: 12px;
        gap: 8px;
    }
`;

export const InfoItem = styled.div`
    display: flex;
    flex-direction: ${props => (props.canShowCodPaymentMethodSelection ? "column" : "row")};
    align-items: ${props => (props.canShowCodPaymentMethodSelection ? "flex-start" : "center")};
    gap: 10px;
    justify-content: space-between;
    padding-bottom: 8px;
    border-bottom: 1px solid #f0f0f0;
    min-width: 0;
    width: 100%;

    &:last-child {
        border-bottom: none;
        padding-bottom: 0;
        flex-direction: column;
        align-items: flex-start;
    }

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        flex-direction: column;
        align-items: flex-start;
        padding-bottom: 12px;
        gap: 8px;

        &:last-child {
            padding-bottom: 0;
        }
    }
`;

export const InfoHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    margin-right: 10px;

    img {
        width: 16px;
        height: 16px;
        flex-shrink: 0;
    }

    b {
        font-size: 13px;
        font-weight: 600;
        color: #333;
        white-space: nowrap;
    }

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        b {
            font-size: 14px;
        }
    }
`;

export const InfoValue = styled.div`
    font-size: 16px;
    font-weight: bold;
    color: #333;
    text-align: right;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        text-align: left;
        width: 100%;
        font-size: 15px;
    }
`;

export const ActionButton = styled.button`
    display: flex;
    align-self: flex-end;
    background: #52c41a;
    border: 1px solid #52c41a;
    border-radius: 6px;
    color: white;
    padding: 8px 16px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    transition: all 0.3s;
    white-space: nowrap;

    &:hover {
        background: #389e0d;
        border-color: #389e0d;
    }

    &:active {
        background: #237804;
        border-color: #237804;
    }

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        width: 100%;
        padding: 10px 16px;
        font-size: 13px;
    }
`;

export const RateDisplay = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    text-align: right;

    .rate-label {
        font-size: 11px;
        color: #666;
        margin-bottom: 2px;
    }

    .rate-value {
        font-size: 16px;
        font-weight: bold;
        color: #389e0d;
        margin-bottom: 2px;
    }

    .rate-period {
        font-size: 10px;
        color: #888;
    }

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        align-items: flex-start;
        text-align: left;
        width: 100%;

        .rate-label {
            font-size: 12px;
        }

        .rate-value {
            font-size: 17px;
        }

        .rate-period {
            font-size: 11px;
        }
    }
`;
